/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '../index';

const findAllOccasions = (brand, whichMessageVariant = 'TEXT') => {
    const fetchIcons = whichMessageVariant === 'ICONS' ? `
    iconImage {
        title
        href
    }` : '';
    return gql`{ findAllOccasions(brand: "${brand}", environment: "${GRAPHQL_ENV}") {
            cardCategory
            code
            displayType
            ${fetchIcons}
            messageText
            name
            rank
            uid
            __typename
        }
    }
`;
};

export default findAllOccasions;
